import { Suspense, lazy } from "react";
import { Navigate, useRoutes, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
// layouts
import DashboardLayout from "./layouts/dashboard";
import UserDetails from "./pages/UserDetail";
// components
import LoadingScreen from "./components/LoadingScreen";
import UpcomingMatches from "./pages/CricketContest/UpcomingMatches";
import ActiveMatchList from "./pages/CricketContest/ActiveMatchList";
import Pool from "./pages/CricketContest/Pool";
import CreatePool from "./pages/CreatePool/CreatePool";
import PoolBreakPoint from "./pages/CreatePool/PoolBreakPoint";
import CricketPointsManagement from "./pages/PointsManagement/CricketPointsManagement";
import FootballPointsManagement from "./pages/PointsManagement/FootballPointsManagement";

import CricketStatusManagement from "./pages/StatusManagement/CricketStatusManagement";
import ContestStatusMangement from "./pages/StatusManagement/ContestStatusMangement";
import FootballStatusManagement from "./pages/StatusManagement/FootballStatusManagement";

//import Notification from './pages/Notification/Notification';
import ActivePoolList from "./pages/CricketContest/ActivePoolList";

// Customization

import ThemeCustomization from "./pages/Customization/ThemeCustomization";

import Category from "./pages/CMS/Category";
import FAQs from "./pages/CMS/FAQs";
import CMS from "./pages/CMS/CMS";
import CMSView from "./pages/CMS/CMSView";

import UpcomingFootballSeriesList from "./pages/SeriesManagement/UpcomingFootballSeriesList";
import UpcomingCricketSeriesList from "./pages/SeriesManagement/UpcomingCricketSeriesList";
import ActiveSeriesCricketList from "./pages/SeriesManagement/ActiveSeriesCricketList";
import ActiveSeriesFootballList from "./pages/SeriesManagement/ActiveSeriesFootballList";
import TeamCricketManager from "./pages/TeamManager/TeamCricketManager";
import TeamFootballManager from "./pages/TeamManager/TeamFootballManager";

import BannerManagement from "./pages/BannerManagement/BannerManagement";

import PlayerCricketManager from "./pages/PlayerManager/PlayerCricketManager";
import PlayerFootballManager from "./pages/PlayerManager/PlayerFootballManager";

import StateManager from "./pages/StateManager/StateManager";

import SeriesCricketManager from "./pages/SeriesManager/SeriesCricketManager";
import SeriesFootballManager from "./pages/SeriesManager/SeriesFootballManager";
import ContactUsList from "./pages/ContactUsList/contact_us_list";
import Transactions from "./pages/TransactionsManagement/Transactions";

import Settings from "./pages/Settings/List";

// Api checking All routes
import GameApi from "./pages/ApiTesting/GameApi";
import BalanceApi from "./pages/ApiTesting/BalanceApi";
import DepositApi from "./pages/ApiTesting/Deposit";

import WithdrawalRequest from "./pages/Withdrawal/List";
import WalletList from "./pages/Wallet/List";

import CricketPlayerAccumulator from "./pages/Accumulator/CricketPlayerAccumulator";
import FootballPlayerAccumulator from "./pages/Accumulator/FootballPlayerAccumulator";

import TDSManager from "./pages/TDSManager/list";
import NotificationCreate from "./pages/Notification/Create";
import NotificationList from "./pages/Notification/List";

import ReportManagementList from "./pages/ReportManagement/List";
import UserVendor from "./pages/UserVendor";
import CricketMatches from "./pages/CronUpdate/CricketMatches";
import FootballMatches from "./pages/CronUpdate/FootballMatches";
import DashboardVendorApp from "./pages/DashboardVendorApp";

const Loadable = (Component) => (props) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { pathname } = useLocation();
  return (
    <Suspense
      fallback={<LoadingScreen isDashboard={pathname.includes("/dashboard")} />}
    >
      <Component {...props} />
    </Suspense>
  );
};

export default function Router() {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  let usetype=localStorage.getItem("usertype");
  console.log("usertype====>>",localStorage.getItem("usertype"),usetype=="0");
  
  return useRoutes([
    {
      path: "/dashboard",
      element: <DashboardLayout />,
      children: [
        {
          path: "app",  
          element: isAuthenticated ? (
            usetype=="0"?<DashboardVendorApp />:
            <DashboardApp />
          ) : (
            <Navigate to="/login" />
          ),
        },
       
        {
          path: "settings",
          element: isAuthenticated ? <Settings /> : <Navigate to="/login" />,
        },

        {
          path: "uservendor/list",
          element: isAuthenticated ? <UserVendor /> : <Navigate to="/login" />,
        },

        {
          path: "user/list",
          element: isAuthenticated ? <User /> : <Navigate to="/login" />,
        },
        {
          path: "user/list/:active",
          element: isAuthenticated ? <User /> : <Navigate to="/login" />,
        },
        {
          path: "user/list/:inactive",
          element: isAuthenticated ? <User /> : <Navigate to="/login" />,
        },

        {
          path: "user-details/:id",
          element: isAuthenticated ? <UserDetails /> : <Navigate to="/login" />,
        },

        {
          path: "sub-admin/list",
          element: isAuthenticated ? (
            <SubadminList />
          ) : (
            <Navigate to="/login" />
          ),
        },
        {
          path: "sub-admin/create",
          element: isAuthenticated ? (
            <SubadminCreate />
          ) : (
            <Navigate to="/login" />
          ),
        },
        {
          path: "sub-admin/view/:id",
          element: isAuthenticated ? (
            <SubadminViewEdit />
          ) : (
            <Navigate to="/login" />
          ),
        },
        {
          path: "sub-admin/edit/:id",
          element: isAuthenticated ? (
            <SubadminViewEdit />
          ) : (
            <Navigate to="/login" />
          ),
        },

        {
          path: "profile",
          element: isAuthenticated ? <Profile /> : <Navigate to="/login" />,
        },
        {
          path: "change-password",
          element: isAuthenticated ? (
            <ChangePassword />
          ) : (
            <Navigate to="/login" />
          ),
        },
        {
          path: "cricket/upcoming_match_list",
          element: isAuthenticated ? (
            <UpcomingMatches />
          ) : (
            <Navigate to="/login" />
          ),
        },
        {
          path: "cricket/contest_list",
          element: isAuthenticated ? <ContestList /> : <Navigate to="/login" />,
        },
        {
          path: "poollist/:id",
          element: isAuthenticated ? <Pool /> : <Navigate to="/login" />,
        },
        {
          path: "pool/:gametype/:id/create",
          element: isAuthenticated ? <CreatePool /> : <Navigate to="/login" />,
        },
        {
          path: "pool/:gametype/:id/break-point",
          element: isAuthenticated ? (
            <PoolBreakPoint />
          ) : (
            <Navigate to="/login" />
          ),
        },
        {
          path: "s/:id",
          element: isAuthenticated ? (
            <ActivePoolList />
          ) : (
            <Navigate to="/login" />
          ),
        },
        {
          path: "activepoollistseries/:id",
          element: isAuthenticated ? (
            <ActivePoolList />
          ) : (
            <Navigate to="/login" />
          ),
        },
        {
          path: "activepoollistmatch/:id",
          element: isAuthenticated ? (
            <ActivePoolList />
          ) : (
            <Navigate to="/login" />
          ),
        },
        {
          path: "cricket/active_match_list",
          element: isAuthenticated ? (
            <ActiveMatchList />
          ) : (
            <Navigate to="/login" />
          ),
        },
        {
          path: "cricket/assign_contest_list",
          element: isAuthenticated ? (
            <ActiveMatchList />
          ) : (
            <Navigate to="/login" />
          ),
        },

        //football management
        {
          path: "football/contest_football_list",
          element: isAuthenticated ? <ContestList /> : <Navigate to="/login" />,
        },
        {
          path: "football/upcoming_football_list",
          element: isAuthenticated ? (
            <UpcomingFootballMatches />
          ) : (
            <Navigate to="/login" />
          ),
        },
        {
          path: "football/active_football_list",
          element: isAuthenticated ? (
            <ActiveFootballList />
          ) : (
            <Navigate to="/login" />
          ),
        },
        {
          path: "activepoollistfootball/:id",
          element: isAuthenticated ? (
            <ActivePoolList />
          ) : (
            <Navigate to="/login" />
          ),
        },

        //series management
        {
          path: "series/cricket/upcomingseries",
          element: isAuthenticated ? (
            <UpcomingCricketSeriesList />
          ) : (
            <Navigate to="/login" />
          ),
        },
        {
          path: "series/cricket/activeseries",
          element: isAuthenticated ? (
            <ActiveSeriesCricketList />
          ) : (
            <Navigate to="/login" />
          ),
        },
        {
          path: "series/cricket/contest",
          element: isAuthenticated ? <ContestList /> : <Navigate to="/login" />,
        },

        {
          path: "series/football/upcomingseriesfb",
          element: isAuthenticated ? (
            <UpcomingFootballSeriesList />
          ) : (
            <Navigate to="/login" />
          ),
        },
        {
          path: "series/football/activeseriesfb",
          element: isAuthenticated ? (
            <ActiveSeriesFootballList />
          ) : (
            <Navigate to="/login" />
          ),
        },
        {
          path: "series/football/contestfb",
          element: isAuthenticated ? <ContestList /> : <Navigate to="/login" />,
        },

        {
          path: "points-management/cricket",
          element: isAuthenticated ? (
            <CricketPointsManagement />
          ) : (
            <Navigate to="/login" />
          ),
        },
        { path: 'points-management/football', element: isAuthenticated ? <FootballPointsManagement /> : <Navigate to="/login" /> },
        // Api Checking routes
        {
          path: "check-api/balance-check-api",
          element: isAuthenticated ? <BalanceApi /> : <Navigate to="/login" />,
        },
        {
          path: "check-api/balance-check-api",
          element: isAuthenticated ? <BalanceApi /> : <Navigate to="/login" />,
        },
        {
          path: "check-api/join-game-api",
          element: isAuthenticated ? <GameApi /> : <Navigate to="/login" />,
        },
        {
          path: "check-api/deposit",
          element: isAuthenticated ? <DepositApi /> : <Navigate to="/login" />,
        },

        {
          path: "status-management/cricket",
          element: isAuthenticated ? (
            <CricketStatusManagement />
          ) : (
            <Navigate to="/login" />
          ),
        },
        {
          path: "status-management/football",
          element: isAuthenticated ? (
            <FootballStatusManagement />
          ) : (
            <Navigate to="/login" />
          ),
        },
        {
          path: "contest-status-mangement/:id",
          element: isAuthenticated ? (
            <ContestStatusMangement />
          ) : (
            <Navigate to="/login" />
          ),
        },

        //CMS management
        {
          path: "cms/category",
          element: isAuthenticated ? <Category /> : <Navigate to="/login" />,
        },
        {
          path: "cms/faqs",
          element: isAuthenticated ? <FAQs /> : <Navigate to="/login" />,
        },
        {
          path: "cms/others",
          element: isAuthenticated ? <CMS /> : <Navigate to="/login" />,
        },
        {
          path: "cms/others/:id",
          element: isAuthenticated ? <CMSView /> : <Navigate to="/login" />,
        },

        //{ path: 'notifications', element: isAuthenticated ? <Notification /> : <Navigate to="/login" /> },

        // Customization
        {
          path: "customization",
          element: isAuthenticated ? (
            <ThemeCustomization />
          ) : (
            <Navigate to="/login" />
          ),
        },

        {
          path: "teams-manager/cricket",
          element: isAuthenticated ? (
            <TeamCricketManager />
          ) : (
            <Navigate to="/login" />
          ),
        },
        {
          path: "teams-manager/football",
          element: isAuthenticated ? (
            <TeamFootballManager />
          ) : (
            <Navigate to="/login" />
          ),
        },

        {
          path: "banner-management",
          element: isAuthenticated ? (
            <BannerManagement />
          ) : (
            <Navigate to="/login" />
          ),
        },

        {
          path: "transactions",
          element: isAuthenticated ? (
            <Transactions />
          ) : (
            <Navigate to="/login" />
          ),
        },

        {
          path: "withdraw-requests",
          element: isAuthenticated ? (
            <WithdrawalRequest />
          ) : (
            <Navigate to="/login" />
          ),
        },

        {
          path: "wallet",
          element: isAuthenticated ? <WalletList /> : <Navigate to="/login" />,
        },

        {
          path: "player-manager/cricket",
          element: isAuthenticated ? (
            <PlayerCricketManager />
          ) : (
            <Navigate to="/login" />
          ),
        },
        {
          path: "player-manager/football",
          element: isAuthenticated ? (
            <PlayerFootballManager />
          ) : (
            <Navigate to="/login" />
          ),
        },

        {
          path: "state-management",
          element: isAuthenticated ? (
            <StateManager />
          ) : (
            <Navigate to="/login" />
          ),
        },

        {
          path: "series-manager/cricket",
          element: isAuthenticated ? (
            <SeriesCricketManager />
          ) : (
            <Navigate to="/login" />
          ),
        },
        {
          path: "series-manager/football",
          element: isAuthenticated ? (
            <SeriesFootballManager />
          ) : (
            <Navigate to="/login" />
          ),
        },

        {
          path: "player-accumulator/cricket",
          element: isAuthenticated ? (
            <CricketPlayerAccumulator />
          ) : (
            <Navigate to="/login" />
          ),
        },
        {
          path: "player-accumulator/football",
          element: isAuthenticated ? (
            <FootballPlayerAccumulator />
          ) : (
            <Navigate to="/login" />
          ),
        },

        {
          path: "tds-manager",
          element: isAuthenticated ? <TDSManager /> : <Navigate to="/login" />,
        },

        {
          path: "notification/list",
          element: isAuthenticated ? (
            <NotificationList />
          ) : (
            <Navigate to="/login" />
          ),
        },
        {
          path: "notification/create",
          element: isAuthenticated ? (
            <NotificationCreate />
          ) : (
            <Navigate to="/login" />
          ),
        },

        {
          path: "contact_us_list",
          element: isAuthenticated ? (
            <ContactUsList />
          ) : (
            <Navigate to="/login" />
          ),
        },

        {
          path: "report_management/",
          element: isAuthenticated ? (
            <ReportManagementList />
          ) : (
            <Navigate to="/login" />
          ),
        },
        {
          path: "cricket_matches",
          element: isAuthenticated ? <CricketMatches /> : <Navigate to="/login" />,
        },
        {
          path: "football_matches",
          element: isAuthenticated ? <FootballMatches /> : <Navigate to="/login" />,
        },
      ],
    },

    {
      path: "/",
      children: [
        { path: "/", element: <Navigate to="/dashboard/app" /> },
        {
          path: "login",
          element: isAuthenticated ? (
            <Navigate to="/dashboard/app" />
          ) : (
            <Login />
          ),
        },
        {
          path: "reset-password",
          element: isAuthenticated ? (
            <Navigate to="/dashboard/app" />
          ) : (
            <ResetPassword />
          ),
        },
        { path: "404", element: <NotFound /> },
        { path: "*", element: <Navigate to="/404" /> },
      ],
    },
    { path: "*", element: <Navigate to="/404" replace /> },
  ]);
}

// IMPORT COMPONENTS
// Authentication
const Login = Loadable(lazy(() => import("./pages/Auth/Login")));
const ResetPassword = Loadable(
  lazy(() => import("./pages/Auth/ResetPassword"))
);
// Dashboard
const DashboardApp = Loadable(lazy(() => import("./pages/DashboardApp")));
// Main
const Profile = Loadable(lazy(() => import("./pages/Profile/Profile")));
const ChangePassword = Loadable(
  lazy(() => import("./pages/Profile/ChangePassword"))
);
const NotFound = Loadable(lazy(() => import("./pages/Page404")));
const User = Loadable(lazy(() => import("./pages/User")));
const SubadminList = Loadable(lazy(() => import("./pages/Subadmin/List")));
const SubadminCreate = Loadable(lazy(() => import("./pages/Subadmin/Create")));
const SubadminViewEdit = Loadable(
  lazy(() => import("./pages/Subadmin/ViewEdit"))
);
//contest
const ContestList = Loadable(
  lazy(() => import("./pages/CricketContest/ContestList"))
);

//series

//football management
const UpcomingFootballMatches = Loadable(
  lazy(() => import("./pages/FootballManagement/UpcomingFootballMatches"))
);
const ActiveFootballList = Loadable(
  lazy(() => import("./pages/FootballManagement/ActiveFootballList"))
);
